import { MainV3ApiBase } from './base';
import { CourseIndexView } from '../types/courses';

export const ReviewableCoursesApis = {
  findAll(): Promise<CourseIndexView[]> {
    return MainV3ApiBase.appendPath('/reviewers/courses').get();
  },
};
